export const BUCKET_STYLES = {
  formal_hta: {
    color: "#1D4ED8",
    bg: "bg-blue-50",
    text: "text-blue-700",
    border: "border-blue-700",
    badge: "bg-blue-50 text-blue-700 border border-blue-200",
  },
  cost_minimisation: {
    color: "#047857",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-700",
    badge: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  },
  hospital_agreement: {
    color: "#B45309",
    bg: "bg-amber-50",
    text: "text-amber-700",
    border: "border-amber-700",
    badge: "bg-amber-50 text-amber-700 border border-amber-200",
  },
};

export const STATUS_STYLES = {
  accepted: { color: "#047857", bg: "bg-emerald-600", label: "Accepted as-is", chip: "bg-emerald-50 text-emerald-700 border border-emerald-200" },
  adaptation: { color: "#B45309", bg: "bg-amber-500", label: "Local adaptation", chip: "bg-amber-50 text-amber-700 border border-amber-200" },
  not_acceptable: { color: "#B91C1C", bg: "bg-red-600", label: "Not acceptable", chip: "bg-red-50 text-red-700 border border-red-200" },
  not_required: { color: "#CBD5E1", bg: "bg-slate-200", label: "Not required", chip: "bg-slate-50 text-slate-500 border border-slate-200" },
};

export const ASSET_TYPES = {
  pivotal_rct: "Randomized Controlled Trial",
  single_arm: "Single-Arm Study",
  meta_analysis: "Meta-Analysis",
  indirect_comparison: "Network Meta-Analysis (NMA)",
  rwe: "Real-World Evidence",
  pro: "Patient-Reported Outcomes",
  utilities: "Utility Study",
  economic_model: "Cost-Effectiveness Analysis",
  budget_impact: "Budget Impact Analysis",
  resource_utilization: "Resource Utilization Study",
  epidemiology: "Epidemiology Study",
};

export const MATURITY_LEVELS = {
  planned: "Planned",
  ongoing: "Ongoing",
  completed: "Completed",
  published: "Published",
  peer_reviewed: "Peer-Reviewed",
};

export const PRIORITY_STYLES = {
  Critical: "bg-red-600 text-white",
  High: "bg-amber-500 text-white",
  Medium: "bg-slate-900 text-white",
  Low: "bg-slate-200 text-slate-600",
};

export const MB_PALETTE = ["#1D4ED8", "#047857", "#B45309", "#0F766E", "#BE123C", "#4338CA"];

export const CERTAINTY_LEVELS = {
  high: { label: "High certainty", chip: "bg-emerald-50 text-emerald-700 border border-emerald-200" },
  moderate: { label: "Moderate certainty", chip: "bg-lime-50 text-lime-700 border border-lime-300" },
  low: { label: "Low certainty", chip: "bg-amber-50 text-amber-700 border border-amber-200" },
  very_low: { label: "Very low certainty", chip: "bg-red-50 text-red-700 border border-red-200" },
};

export const LEVEL_STYLES = {
  Mandatory: "bg-slate-900 text-white",
  Preferred: "bg-slate-200 text-slate-700",
  Optional: "bg-white text-slate-500 border border-slate-300",
};
